/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type GetAdvancedQuickNoteQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetAdvancedQuickNoteQuery = {
  __typename?: 'Query'
  patient: { __typename?: 'Patient'; uid: string; quickNote?: string | null }
}

export type UpdateAdvancedQuickNoteMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  quickNote: Types.Scalars['String']['input']
}>

export type UpdateAdvancedQuickNoteMutation = {
  __typename?: 'Mutation'
  updatePatientQuickNote: { __typename?: 'Patient'; uid: string }
}

export const GetAdvancedQuickNoteDocument = gql`
  query getAdvancedQuickNote($uid: ID!) {
    patient(uid: $uid) {
      uid
      quickNote
    }
  }
`

/**
 * __useGetAdvancedQuickNoteQuery__
 *
 * To run a query within a React component, call `useGetAdvancedQuickNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedQuickNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedQuickNoteQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetAdvancedQuickNoteQuery(
  baseOptions: Apollo.QueryHookOptions<GetAdvancedQuickNoteQuery, GetAdvancedQuickNoteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedQuickNoteQuery, GetAdvancedQuickNoteQueryVariables>(
    GetAdvancedQuickNoteDocument,
    options
  )
}
export function useGetAdvancedQuickNoteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAdvancedQuickNoteQuery, GetAdvancedQuickNoteQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedQuickNoteQuery, GetAdvancedQuickNoteQueryVariables>(
    GetAdvancedQuickNoteDocument,
    options
  )
}
export type GetAdvancedQuickNoteQueryHookResult = ReturnType<typeof useGetAdvancedQuickNoteQuery>
export type GetAdvancedQuickNoteLazyQueryHookResult = ReturnType<typeof useGetAdvancedQuickNoteLazyQuery>
export type GetAdvancedQuickNoteQueryResult = Apollo.QueryResult<
  GetAdvancedQuickNoteQuery,
  GetAdvancedQuickNoteQueryVariables
>
export const UpdateAdvancedQuickNoteDocument = gql`
  mutation updateAdvancedQuickNote($uid: ID!, $quickNote: String!) {
    updatePatientQuickNote(uid: $uid, quickNote: $quickNote) {
      uid
    }
  }
`
export type UpdateAdvancedQuickNoteMutationFn = Apollo.MutationFunction<
  UpdateAdvancedQuickNoteMutation,
  UpdateAdvancedQuickNoteMutationVariables
>

/**
 * __useUpdateAdvancedQuickNoteMutation__
 *
 * To run a mutation, you first call `useUpdateAdvancedQuickNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdvancedQuickNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdvancedQuickNoteMutation, { data, loading, error }] = useUpdateAdvancedQuickNoteMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      quickNote: // value for 'quickNote'
 *   },
 * });
 */
export function useUpdateAdvancedQuickNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateAdvancedQuickNoteMutation, UpdateAdvancedQuickNoteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateAdvancedQuickNoteMutation, UpdateAdvancedQuickNoteMutationVariables>(
    UpdateAdvancedQuickNoteDocument,
    options
  )
}
export type UpdateAdvancedQuickNoteMutationHookResult = ReturnType<typeof useUpdateAdvancedQuickNoteMutation>
export type UpdateAdvancedQuickNoteMutationResult = Apollo.MutationResult<UpdateAdvancedQuickNoteMutation>
export type UpdateAdvancedQuickNoteMutationOptions = Apollo.BaseMutationOptions<
  UpdateAdvancedQuickNoteMutation,
  UpdateAdvancedQuickNoteMutationVariables
>
